import Swiper from '../plugins/SwiperPlugin.js';
import '../plugins/ResponsiveHelper.js';

export default function initSwiper() {

	document.querySelectorAll('.js-mobile-scrollbar-swiper').forEach(carousel => {
		let swiper = null;

    // eslint-disable-next-line no-undef
		ResponsiveHelper.addRange({
			'..1023': {
				on: function() {
					swiper = new Swiper(carousel, {
						slideClass: 'slide-gallery',
						spaceBetween: 0,
						threshold: 30,
						touchAngle: 30,
						loop: false,
						slidesPerView: 'auto',
						scrollbar: {
							el: carousel.querySelector('.swiper-scrollbar'),
							draggable: true,
							hide: false
						}
					});
				}
			},
			'1024..': {
				on: function() {
					swiper && swiper.destroy(true, true);
					swiper = null;
				}
			}
		});
	});


	document.querySelectorAll('.js-scrollbar-swiper').forEach(carousel => {
		const swiper = new Swiper(carousel, {
			slideClass: 'slide-gallery',
			spaceBetween: 0,
			threshold: 30,
			touchAngle: 30,
			loop: false,
			slidesPerView: 'auto',
			scrollbar: {
				el: carousel.querySelector('.swiper-scrollbar'),
				draggable: true,
				hide: false
			}
		});
	});

  document.querySelectorAll('.js-fair-navigation-menu').forEach(menu => {
    let swiper = null;

    let menuContainer = document.querySelectorAll('.js-fair-navigation-menu .navigation__nav');
    menuContainer = menuContainer.length > 0 ? menuContainer[0] : null;
    let menuWidth = (menuContainer ? menuContainer.clientWidth : menu.clientWidth) + 60;

    // eslint-disable-next-line no-undef
    ResponsiveHelper.addRange({
      [`..${(menuWidth - 1)}`]: {
        on: function() {
          var activeSlide = document.querySelectorAll('.js-fair-navigation-menu .navigation__nav__item--active');
          activeSlide = activeSlide.length > 0 ? activeSlide[0] : null;

          swiper = new Swiper(menu, {
            initialSlide: activeSlide ? activeSlide.dataset.slideNumber : 1,
            slidesPerView: 'auto',
            slidesPerGroup: 3,
            centeredSlides: true,
            centeredSlidesBounds: true,
            wrapperClass: 'navigation__nav',
            slideClass: 'navigation__nav__item',
            navigation: {
              nextEl: '.navigation__nav__button-next',
              prevEl: '.navigation__nav__button-prev',
            },
            freeMode: {
              enabled: true,
              sticky: true,
            },
          });
        }
      },
      [`${menuWidth}..`]: {
        on: function() {
          swiper && swiper.destroy(true, true);
          swiper = null;
        }
      }
    });
  });

  function adjustSlideHeights(wrapper, slideClass) {
    const slides = wrapper.querySelectorAll(`.${slideClass}`);
    let maxHeight = 0;

    slides.forEach((slide) => {
      slide.style.height = 'auto';
      const slideHeight = slide.offsetHeight;
      if (slideHeight > maxHeight) {
        maxHeight = slideHeight;
      }
    });
    slides.forEach((slide) => {
      slide.style.height = `${maxHeight}px`;
    });
  }

  document.querySelectorAll('.js-scrollbar-swiper-artworks').forEach(carousel => {
    new Swiper(carousel, {
      slideClass: 'grid-item',
      spaceBetween: 0,
      threshold: 30,
      touchAngle: 30,
      loop: false,
      slidesPerView: 'auto',
      scrollbar: {
        el: carousel.parentElement.querySelector('.swiper-scrollbar'),
        draggable: true,
        hide: false
      },
      on: {
        init: function () {
          adjustSlideHeights(this.wrapperEl, this.params.slideClass);
        },
        resize: function () {
          adjustSlideHeights(this.wrapperEl, this.params.slideClass);
        }
      }
    });
  });
}
